export const DELIVERY_TAGS = {
    FLEX: 'flex',
    CHANGE: 'exchange',
    RETURN: 'return'
}

export const DELIVERY_TAGS_LABELS = {
    FLEX: 'Flex',
    CHANGE: 'Cambio',
    RETURN: 'Devolución'
}

export const DELIVERY_TAGS_LIST = [
    {
        value: DELIVERY_TAGS.FLEX,
        label: DELIVERY_TAGS_LABELS.FLEX
    },
    {
        value: DELIVERY_TAGS.CHANGE,
        label: DELIVERY_TAGS_LABELS.CHANGE
    },
    {
        value: DELIVERY_TAGS.RETURN,
        label: DELIVERY_TAGS_LABELS.RETURN
    }
]

